<template>
  <base-modal :modal-id="modalId">
    <template v-slot:header>
      <button
        type="button"
        class="d-sm-none btn btn-arrow"
        data-dismiss="modal"
        @click="$bvModal.hide(modalId)"
      >
        <img src="/images/svg/global/left_arrow.svg" />
      </button>

      <h4 class="modal-title mb-0 d-sm-none">{{ _T('Email') }}</h4>
      <h4 class="modal-title mb-0 d-none d-sm-block">
        {{ _T('Change Email Address') }}
      </h4>
    </template>
    <template v-slot:modal-body>
      <form class="default-form">
        <div class="form-group">
          <label>{{ _T('Email address') }}</label>
          <input type="text" class="form-control" v-model="email" />
        </div>
        <div class="form-group">
          <label>
            {{ domainBasedBrand ? _T_DB(currentBrand, 'name') : _T('Go Order')
            }}{{ ' ' + _T('password') }}
          </label>
          <input
            type="password"
            class="form-control d-sm-block d-none"
            v-model="confirm_password"
          />
          <div class="input-group d-sm-none">
            <input
              type="password"
              class="form-control"
              placeholder="Placeholder"
            />
            <div class="input-group-append">
              <span class="input-group-text"
                ><img src="/images/svg/account/eye.svg"
              /></span>
            </div>
          </div>
        </div>
        <div class="btns">
          <b-button type="button" class="btn btn-outline" @click="closeModal()">
            {{ _T('Cancel') }}
          </b-button>
          <progress-bar v-if="processInProgress(process)">
            {{ _T('Saving') }}
          </progress-bar>
          <b-button
            v-else
            type="button"
            class="btn btn-danger"
            data-toggle="modal"
            @click="changeEmail"
            data-dismiss="modal"
          >
            {{ _T('Save') }}
          </b-button>
        </div>
      </form>
    </template>
  </base-modal>
</template>

<script>
import BaseModal from '../BaseModal'
import { mapGetters } from 'vuex'
import ProgressBar from '@/components/Elements/ProgressBar'
import { handleApiErrors } from '@/utils/main_utils.js'
export default {
  name: 'ChangeEmail',
  components: {
    BaseModal,
    ProgressBar,
  },
  data() {
    return {
      confirm_password: '',
      email: '',
      process: 'change-email',
      modalId: 'change-email',
    }
  },
  computed: {
    ...mapGetters([
      '_T',
      'web_user',
      'processInProgress',
      'processInProgress',
      'domainBasedBrand',
      '_T_DB',
      'currentBrand',
    ]),
  },
  methods: {
    closeModal() {
      if (this.processInProgress(this.process))
        this.$store.dispatch('stopProcess', this.process)
      this.$bvModal.hide(this.modalId)
    },
    proceedFurther() {
      this.$bvModal.hide(this.modalId)
      this.$bvModal.show('verify-email')
    },
    changeEmail() {
      if (this.email == this.web_user.email) {
        this.$store.dispatch('showNotification', {
          text: this._T('Same email can not be updated'),
          status: 'error',
        })
      } else if (!this.email || !this.confirm_password) {
        this.$store.dispatch('showNotification', {
          text: this._T('All fields required'),
          status: 'error',
        })
      } else {
        if (!this.processInProgress(this.process)) {
          this.$store.dispatch('startProcess', {
            process: this.process,
            progress: true,
          })
          this.$store.commit('SET_EMAIL_BANNNER', false)
          this.$store
            .dispatch('update_user_email', {
              email: this.email,
              confirm_password: this.confirm_password,
              email_verified: false,
            })
            .then(resp => {
              let responseData = resp.data
              if (responseData.status === 'form_errors') {
                let errors = handleApiErrors(responseData.form_errors)
                this.$store.dispatch('showNotification', {
                  text: this._T(errors),
                  status: 'error',
                })
              } else {
                this.$store.dispatch('showNotification', {
                  text: this._T('Record updated succesfully'),
                  status: 'success',
                })
                this.$store
                  .dispatch('load_customer', true)
                  .then(() => this.$store.commit('SET_EMAIL_BANNNER', true))
                this.email = this.web_user.email
                this.$bvModal.hide(this.modalId)
              }
            })
            .catch(err => {
              this.$store.dispatch('showNotification', {
                text: this._T(err),
                status: 'error',
              })
            })
            .finally(() => {
              this.$store.dispatch('stopProcess', this.process)
            })
        }
      }
    },
  },
  mounted() {
    this.email = this.web_user.email
  },
}
</script>

<style lang="scss" scoped>
.body-rtl {
  .edit-profile {
    .modal-body {
      .btns {
        text-align: left;
        .btn {
          + .btn {
            margin-right: $px8;
            margin-left: unset;
          }
        }
      }
      label {
        text-align: right;
        float: right;
      }
    }
  }
}
.check-email {
  h6 {
    font-size: $px14;
    line-height: $px22;
    letter-spacing: 0.5px;
    margin-bottom: $px5;

    + h6 {
      font-weight: 600;
      letter-spacing: 0.005em;
      margin-bottom: 0;
    }
  }

  .btns {
    margin-top: $px28;
  }
}
</style>
